import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoEsquemasEsquemaComisionistasGraficaComponent {
  data
  colores
  etiquetas = []
  porcentajes = []

  $onChanges (changes) {
    if (changes.data) {
      this.etiquetas = this.data.map((item) => item.nombre)
      this.porcentajes = this.data.map((item) => item.comision_porcentaje)
    }
  }
}

module.component('fanProyectoEsquemasEsquemaComisionistasGrafica', {
  controller: FanProyectoEsquemasEsquemaComisionistasGraficaComponent,
  template,
  bindings: {
    data: '<',
    colores: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/esquema/comisionistas/grafica/component.js